import { authorizedGet, authorizedPost, authorizedPut } from './baseApiService';
import {
  IApplyShouttOpp,
  INewOpportunityForm,
  IOppApplyExternalReponse,
  IOpportunity,
  IScrapedDetails as IScrapedDetails,
  OpportunityStatus,
} from 'global/interfaces/opportunity';
import { PagedResult } from 'global/interfaces/PagedResult';
import { getQueryParams } from 'utils/url';

const resource = 'Opportunity';

export async function postNewOpportunity(opportunityDetails: INewOpportunityForm) {
  return await authorizedPost(`${resource}`, opportunityDetails);
}

export async function getOpportunities(searchParams?: URLSearchParams): Promise<PagedResult<IOpportunity[]>> {
  return await authorizedGet<PagedResult<IOpportunity[]>>(`${resource}?${searchParams ?? ''}`);
}

export async function getTopNLatestOpportunities(topN: number): Promise<PagedResult<IOpportunity[]>> {
  return await authorizedGet<PagedResult<IOpportunity[]>>(`${resource}?latestAlways=true&pageSize=${topN}`);
}

export async function getMyOpportunities(lastNDays: number): Promise<IOpportunity[]> {
  return await authorizedGet<IOpportunity[]>(`${resource}/my-opportunities?lastNDays=${lastNDays}`);
}

export async function applyToExternal(opportunityId: string): Promise<IOppApplyExternalReponse> {
  return await authorizedPost<IOppApplyExternalReponse>(
    `${resource}/apply-to-external?opportunityId=${opportunityId}`,
    {},
  );
}

export async function applyToShoutt(applyModel: IApplyShouttOpp): Promise<boolean> {
  return await authorizedPost<boolean>(`${resource}/apply-to-shoutt-opp`, applyModel);
}

export async function opportunityViewed(opportunityId: string) {
  return await authorizedPost(`${resource}/viewed?opportunityId=${opportunityId}`, {});
}

export async function payWalled(opportunityId: string) {
  return await authorizedPost(`${resource}/pay-walled?opportunityId=${opportunityId}`, {});
}

export async function profileNotApproved(opportunityId: string) {
  return await authorizedPost(`${resource}/profile-not-approved?opportunityId=${opportunityId}`, {});
}

export async function messagePoster(opportunityId: string) {
  return await authorizedPost(`${resource}/message-poster?opportunityId=${opportunityId}`, {});
}

export async function applied(opportunityId: string) {
  return await authorizedPost(`${resource}/applied?opportunityId=${opportunityId}`, {});
}

export async function notInterested(opportunityId: string) {
  return await authorizedPost(`${resource}/not-interested?opportunityId=${opportunityId}`, {});
}

export async function getAdminOpportunities(filters: URLSearchParams): Promise<IOpportunity[]> {
  return await authorizedGet<IOpportunity[]>(`${resource}/admin?${filters}`);
}

export async function updateOpportunityStatus(params: { opportunityId: string; status: OpportunityStatus }) {
  return await authorizedPut<IOpportunity[]>(`${resource}/update-status?${getQueryParams(params)}`, {});
}

export async function getOpportunity(opportunityId: string): Promise<IOpportunity> {
  return await authorizedGet<IOpportunity>(`${resource}/${opportunityId}`);
}

export async function getScrapeDetails(opportunityId: string): Promise<IScrapedDetails> {
  return await authorizedGet<IScrapedDetails>(`GigScraper/scrape-details?opportunityId=${opportunityId}`);
}

export async function getOpportunityForConversion(
  opportunityId: string,
  accessToken: string | null,
): Promise<IOpportunity> {
  return await authorizedGet<IOpportunity>(`${resource}/oppforconversion/${opportunityId}?accessToken=${accessToken}`);
}

export async function getApplicants(opportunityId: string, accessToken: string | null): Promise<IOpportunity> {
  return await authorizedGet<IOpportunity>(`${resource}/applicants/${opportunityId}?accessToken=${accessToken}`);
}

export async function updateOpportunity(
  opportunityDetails: INewOpportunityForm,
  opportunityId: string,
  approve: boolean,
) {
  return await authorizedPut(`${resource}/${opportunityId}?approve=${approve}`, opportunityDetails);
}

export async function updateOpportunityForConversion(
  opportunityDetails: INewOpportunityForm,
  opportunityId: string,
  accessToken: string | null,
) {
  return await authorizedPut(
    `${resource}/oppforconversion/${opportunityId}?accessToken=${accessToken}`,
    opportunityDetails,
  );
}

export async function getMyApplications(): Promise<IOpportunity[]> {
  return await authorizedGet(`${resource}/my-applications`);
}
